import React, { useEffect, useState, useRef, Fragment } from 'react'
import { Steps, } from 'antd'


export const stepOptions = [
    {title:'基础信息审核',value:0},
    {title:'合规资质认证',value:1},
]
const StepsComponents=(props)=>{
    const { current, stepChange, direction = 'horizontal' } = props

    return (
        <Steps progressDot current={current} onChange={stepChange} direction={direction}
        items={stepOptions}>
        </Steps>
    )
}

export default StepsComponents



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/components/steps.js